import { FC, CSSProperties } from "react";
import "./style.scss";

interface TextAreaPropsTypes {
  placeholder?: string;
  id?: string;
  value: any;
  style?: CSSProperties;
  disabled?: boolean;
  maxLength?: number;
  withCounter?: boolean;
  onChange?: (e: any) => void;
}

const TextArea: FC<TextAreaPropsTypes> = ({
  placeholder = "",
  value,
  withCounter = true,
  maxLength = 200,
  style,
  disabled,
  onChange,
  id
}) => {
  return (
    <>
      <div className={`text-area-wrapper`}>
        <textarea
          maxLength={maxLength}
          className={`text-area-component ${disabled ? "disabled" : ""}`}
          style={style}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          id={id}
        />
        {withCounter && (
          <span className='text-counters'>{maxLength - value.length} characters left</span>
        )}
      </div>
    </>
  );
};

export default TextArea;
